import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import apiFun from "./http/api.js";
import BaiduMap from 'vue-baidu-map'
// import '@/utils/rem.js'

Vue.use(BaiduMap, {
  ak: "64kpWI7A01PfbZs0FIi5cjmPr1Qcgj2K"
});
Vue.use(ElementUI);
Vue.prototype.$apiFun = apiFun;//请求接口api
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
